export default __webpack_public_path__ + "static/media/AE9.0b560e30.jpg";